import classNames from 'classnames';
import Arrow from 'components/shared/arrow';
import { useState, useEffect } from 'react';
import styles from './backToTopButton.module.scss';

const BackToTopButton = ({ resources, className, globalModules }) => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // show the button only if the page is scrolled down
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // clear event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!showButton) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleBackToTop}
      className={classNames(styles.backToTopButton, className)}
      style={{
        backgroundColor: globalModules?.btncolors?.backToTopButtonColor?.text,
      }}
    >
      <Arrow
        width="1.6rem"
        height="1.6rem"
        color={globalModules?.btncolors?.backToTopButtonTextColor?.text}
        className={styles.buttonArrow}
      />
    </button>
  );
};

export default BackToTopButton;
